import { getAxiosInstance } from "../../../api";

export const getDeliveryCertificate = async (id, slug) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.get(
      `delivery/old-certificate/list?receipt_id=${id}&process_slug=${slug}`
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const approveCertificate = async (params) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`delivery/old-certificate/submit`, params);
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const getPrintSlip = async (id) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.get(
      `/delivery/old-certificate/slip?stock_receipt_id=${id}`
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const getPrintChellan = async (id) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.get(
      `/delivery/old-certificate/create-challan?stock_receipt_id=${id}`
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};
export const passReissueAll = async (params) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(
      `/employee-dashboard/old-certificate/bulk-status-complete`,
      params
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const uploadDeliveryChallan = async (params) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(`/delivery/recheck/recheck-delivery-challan-upload`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const downloadDeliveryReissueExcel = async (receiptId, key) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(
      `verification/recheck-excel-download`,
      { receipt_id: receiptId, key }
    );
    return response;
  } catch (error) {
    return error.response.data;
  }
};

export const updateReissuePrintData = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/delivery/old-certificate/update`, body);
    return res;
  } catch (error) {
    return error.response.data;
  }
};
